const digest = 'a495adf013765bc5f856dc371074e63178352030b5e9308241390916ec384ecd';
const css = `._zIndexControl_8uy6d_1{position:relative;z-index:1}`;
(function() {
  if ( global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'zIndexControl': '_zIndexControl_8uy6d_1' };
export const zIndexControl = '_zIndexControl_8uy6d_1';
export { css, digest };